import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { AlveriCmsPreset } from './theme/alveri-cms-preset';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore } from '@ngrx/router-store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { appEffects, appReducers } from './store/app.store';
import { provideTranslocoConfig } from './transloco.config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastConfig } from './toast.config';
import { provideChardiApiWithInterceptor } from './core/environment-providers/chardi-api.provider';
import { provideCmsApiWithInterceptor } from './core/environment-providers/cms-api.provider';
import { provideApiWithInterceptor } from './core/environment-providers/api.provider';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { getPrimeNGTranslation } from './app.utils';
import { provideNgxStripe } from 'ngx-stripe';
import { EnvConstants } from './shared/constants/env.constantes';
import { mockInterceptor } from './core/interceptors/mock.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideNgxStripe(EnvConstants.STRIPE_PUBLISHABLE_KEY),
    provideToastConfig(),
    provideHttpClient(
      withInterceptors([authInterceptor, mockInterceptor])
    ),
    provideCmsApiWithInterceptor(),
    provideChardiApiWithInterceptor(),
    provideApiWithInterceptor(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AlveriCmsPreset,
        options: {
          darkModeSelector: false
        },
      },
      translation: getPrimeNGTranslation()
    }),
    provideStore(appReducers),
    provideEffects(appEffects),
    provideRouterStore(),
    provideStoreDevtools({ maxAge: 25, logOnly: environment.production }),
    provideTranslocoConfig()
  ],
};
